var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "subtitle-2 pb-2"
    },
    [
      _c(
        "router-link",
        {
          attrs: {
            to: "/websites/"
          }
        },
        [_vm._v(" " + _vm._s(_vm.breadcrumbsData.root) + " ")]
      ),
      _c("span", [_vm._v(" / ")]),
      _c(
        "router-link",
        {
          attrs: {
            to: _vm.breadcrumbsData.hostingPlanPath
          }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.breadcrumbsData.hostingPlan) +
              " (" +
              _vm._s(_vm.breadcrumbsData.rootDomain) +
              ") "
          )
        ]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.breadcrumbsData.domain,
              expression: "breadcrumbsData.domain"
            }
          ]
        },
        [_vm._v(" / ")]
      ),
      _vm._v(" " + _vm._s(_vm.breadcrumbsData.domain) + " ")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }